<template>
  <input
    type="text"
    @focus="resetSelectedProduct"
    class="form-control"
    readonly
    v-model="placeholder"
    id=""
    v-if="selectedProduct"
  />

  <el-select
    v-else
    @keyup.enter.native="searchProductBarcode"
    @change="productSelected"
    class="search productQuery darkBorder"
    @focus="options = []"
    v-model="value"
    :loading-text="loadingMsg"
    :no-data-text="noDataMsg"
    filterable
    remote
    :clearable="true"
    placeholder="بحث المنتجات بالاسم"
    :remote-method="remoteMethod"
    :loading="loading"
  >
    <!-- allow-create -->
    <div class="container-fluid">
      <div class="row headerSearch">
        <div class="col-md-3 p-0">
          <Span>السعر</Span>
        </div>

        <div class="col-md-7 p-0">
          <span style="float: right">اسم المنتج</span>
        </div>
        <div class="col-md-2 p-0">
          <span style="float: right"> المخزون</span>
        </div>
      </div>
    </div>
    <!-- <el-option slot="empty" value="">
    <span>sameh</span>
  </el-option> -->
    <el-option
      ref="productQuery"
      v-for="item in options"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
      <div class="container-fluid">
        <div class="row searchBody">
          <div class="col-md-3 p-0">
            <span v-if="item.prices.length > 0">
              {{ item.prices[0].sale_price }}</span
            >
          </div>

          <div class="col-md-7 p-0">
            <span style="float: right"> {{ item.name }}</span>
          </div>
          <div class="col-md-2 p-0">
            <Span
              style="float: right"
              class=""
              :class="[
                (item.inventories[0].pivot.qty -
                  item.inventories[0].pivot.hold_qty) /
                  item.units_per_package <=
                0
                  ? 'red'
                  : 'number',
              ]"
              >{{
                numberToFixed(
                  (item.inventories[0].pivot.qty -
                    item.inventories[0].pivot.hold_qty) /
                    item.units_per_package
                )
              }}
            </Span>
          </div>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import axiosApi from "@/plugins/axios.js";

export default {
  props: ["customer", "activeSide", "allStock"],

  data() {
    return {
      noDataMsg: "لا توجد بيانات متاحه",
      loadingMsg: " ... جاري تحميل البيانات",
      options: [],
      placeholder: "",
      value: null,
      loading: false,
      selectedProduct: null,
    };
  },
  mounted() {},
  methods: {
    searchProductBarcode() {
      let barcode = document.querySelector(".productQuery input").value;
      if (this.customer == null) {
        this.$message({
          type: "error",
          message: "عفوا حدد العميل اولا",
        });
      } else if (barcode.trim() == "") {
        // this.$message({
        //   type: "error",
        //   message: "عفوا حدد الباركود اولا",
        // });
      } else {
        const loading = this.$loading({
          lock: true,
          text: "جاري بحث المنتجات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axiosApi
          .get(
            `products/barcode-search?barcode=${barcode.trim()}&customer=${
              this.customer.id
            }`
          )
          .then((res) => {
            console.log("========= selected product ===========", res.data);
            this.options = [];
            this.$emit("selectedProductWithBarcode", {
              product: res.data[0],
              barcode: barcode.trim(),
            });
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "عفوا لا يوجد باركود للمنتج المتاح",
            });
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    setValue(value) {
      this.value = value;
      this.selectedProduct = value;
      if (this.value != null) {
        this.placeholder = value.name;
      } else {
        this.placeholder = "";
      }
    },
    resetSelectedProduct() {
      this.selectedProduct = null;
      this.placeholder = "";
      this.$emit("selectedProduct", {
        product: this.selectedProduct,
      });
      setTimeout(() => {
        document.querySelector(".productQuery input").focus();
      }, 100);
    },
    productSelected() {
      console.log("productSelected", this.value);
      this.placeholder = this.value.name;
      this.selectedProduct = this.options.filter((product) => {
        // console.log("product", product);
        if (product.id == this.value) {
          return product;
        }
      })[0];

      this.$emit("selectedProduct", {
        product: this.selectedProduct,
      });
    },
    remoteMethod(query) {
      if (this.customer != null) {
        if (query !== "") {
          this.selectedLabel = query;

          this.loading = true;
          axiosApi
            .get(`products/search?name=${query}&customer=${this.customer.id}`)
            .then((res) => {
              this.loading = false;

              let hasStock = res.data;

              if (this.allStock == false) {
                hasStock = res.data.filter((product) => {
                  // console.log(product.name + "-" +product.inventories[0].pivot.qty +"-"+product.inventories[0].pivot.hold_qty)
                  if (
                    product.inventories.length > 0 &&
                    product.inventories[0].pivot.qty -
                      product.inventories[0].pivot.hold_qty >
                      0
                  ) {
                    // console.log(product)
                    return product;
                  }
                });
              }
              this.options = hasStock;
            })
            .catch((e) => {
              this.loading = false;

              console.log(e);
            });
        } else {
          this.options = [];
        }
      } else {
        this.$message({
          // type: "warning",
          type: "error",
          message: "عفوا حدد العميل اولا",
        });

        document.querySelector(".productQuery input").value = "";

        document.querySelector(".customerQuery input").focus();
      }
    },
  },
};
</script>
